import React from 'react'
import { useHostContext } from '../Common/HostContext'
import { FeatureFlagKeyName, FeatureValueType, featureDefaults } from '@mobi/settings/featureFlags'

export function useHostContextFeature<T extends FeatureFlagKeyName>(key: T): FeatureValueType<T> {
  const { features } = useHostContext()

  const [featureFlagValue, setFeatureFlagValue] = React.useState<FeatureValueType<T> | boolean>(
    () => {
      return featureDefaults[key]
    }
  )

  React.useEffect(() => {
    const fetchData = async () => {
      const featureFlagValue = await features?.hasFeature(key)
      if (featureFlagValue !== undefined) {
        setFeatureFlagValue(featureFlagValue)
      }
    }
    fetchData()
  }, [key, features])

  return featureFlagValue as FeatureValueType<T>
}
